import { searchConfig } from '../config/searchConfig';

export interface SearchItem {
    label: string;
    value: string;
    icon: string;
}

const { storageKey, maxItems, icon } = searchConfig.recentSearches;

export const getRecentSearches = (): SearchItem[] => {
    if (typeof window === 'undefined') return [];
    try {
        const stored = localStorage.getItem(storageKey);
        return stored ? JSON.parse(stored) : [];
    } catch (error) {
        console.error('Error retrieving search terms from localStorage', error);
        return [];
    }
};

export const saveSearchTerm = (term: string) => {
    if (!term || typeof window === 'undefined') return;

    try {
        const stored = localStorage.getItem(storageKey);
        let searches: SearchItem[] = stored ? JSON.parse(stored) : [];

        // Filter out if already exists to re-add it at the top
        searches = searches.filter((item) => item.value !== term);

        searches.unshift({ label: term, value: term, icon });

        if (searches.length > maxItems) {
            searches = searches.slice(0, maxItems);
        }

        localStorage.setItem(storageKey, JSON.stringify(searches));
    } catch (error) {
        console.error('Error saving search term to localStorage', error);
    }
};
